import * as z from 'zod';

import {RelationshipType} from 'models/worker/utils/RelationshipType';

export const relationshipTypeFormEnum = z.nativeEnum(RelationshipType);

export const nextOfKinForm = z.object({
    nokRelationship: relationshipTypeFormEnum,
    nokEmail: z.string().min(1),
    nokFirstName: z.string().min(1),
    nokLastName: z.string().min(1),
    nokPhoneNumber: z.string().min(7),
});

export interface INextOfKinFormData {
    nokEmail: string;
    nokFirstName: string;
    nokLastName: string;
    nokPhoneNumber: string
    nokRelationship: RelationshipType;
}
